import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import OurStory from "./pages/OurStory";
import Gallery from "./pages/Gallery";
import Program from "./pages/Program";
import FAQ from "./pages/FAQ";
import Maps from "./pages/Maps";
import InfosCI from "./pages/InfosCI";
import Guestbook from "./pages/Guestbook";
import Accommodation from "./pages/Accommodation";
import Transport from "./pages/Transport";
import Contacts from "./pages/Contacts";
import PracticalInfo from "./pages/PracticalInfo";
import Gifts from "./pages/Gifts";
import RSVP from "./pages/RSVP";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/program" element={<Program />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/maps" element={<Maps />} />
            <Route path="/infos-ci" element={<InfosCI />} />
            <Route path="/guestbook" element={<Guestbook />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/transport" element={<Transport />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/practical-info" element={<PracticalInfo />} />
            <Route path="/gifts" element={<Gifts />} />
            <Route path="/rsvp" element={<RSVP />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
